import createSelector from 'selectorator';

import { EditingRoleState } from '.';

const getEditingRole = createSelector(['roles'], ({ editingRole }): EditingRoleState => editingRole);

const getStatus = createSelector(['roles.status']);

const hasSetEditingRole = createSelector(
  [getEditingRole],
  (editingRole: EditingRoleState): boolean => !!editingRole.id,
);

const getIsSaving = createSelector(
  [getStatus],
  ({ loading }) => loading,
);

const getEditingRoleHasBeenEdited = createSelector(
  [getEditingRole],
  (editingRole: EditingRoleState): boolean => editingRole.hasBeenEdited,
);

const rolesSelectors = {
  getRoles: createSelector(['roles.roles']),
  getStatus,
  getEditingRole,
  getEditingRoleHasBeenEdited,
  hasSetEditingRole,
  getIsSaving,
};

export default rolesSelectors;
